import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ch-right",
  "use": "icon-ch-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevrons-right\" id=\"icon-ch-right\"><polyline points=\"13 17 18 12 13 7\" /><polyline points=\"6 17 11 12 6 7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol